<template>
	<div class="">
		<div class="chang_box"  v-loading="isTosub">
			<el-form label-position="right" label-width="180px" :model="ruleForm" :rules="rules" ref="ruleForm">
				<el-form-item label="请输入旧密码：" prop="pwd">
					<el-input v-model="ruleForm.pwd" show-password></el-input>
				</el-form-item>
				<el-form-item label="请输入新密码：" prop="pass">
					<el-input v-model="ruleForm.pass" show-password></el-input>
				</el-form-item>
				<el-form-item label="请再次确认密码：" prop="checkPass">
					<el-input v-model="ruleForm.checkPass" show-password></el-input>
				</el-form-item>
				<el-form-item>
					<div class="laing_btn next"  @click="setUserPwd">确定</div>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import {
		chkPasswd
	} from '@/utlis/formrules.js'
	export default {
		data() {
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
				if (this.ruleForm.checkPass !== '') {
					this.$refs.ruleForm.validateField('checkPass');
				}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.pass) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				isTosub:false,
				ruleForm: {
					pwd: '',
					pass: '',
          			checkPass: '',
				},
				rules: {
					pwd: [{ required: true, message: '请输入旧密码', trigger: 'blur' },],
					pass: [{ required: true, message: '请输入新密码', trigger: 'blur' }, { validator: validatePass, trigger: 'blur' } ],
					checkPass: [{ required: true, message: '请再次输入密码', trigger: 'blur' }, { validator: validatePass2, trigger: 'blur' } ],
				}
			}
		},
		methods: {
			setUserPwd(){
				this.$refs.ruleForm.validate(async value=>{
					if(!value)return;
					let ruleForm = this.ruleForm;
					this.isTosub = true;
					let {code} = await this.api.PostuserupdatePwd({
						old_pwd:ruleForm.pwd,
						new_pwd:ruleForm.checkPass,
						password:ruleForm.pass
					});
					this.isTosub = false;
					if(code==200){
						this.$message({ message: '修改密码成功', type: 'success' });
						this.$refs.ruleForm.resetFields();
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
.chang_box{
	width: 500px;
}
</style>
